<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_viii"><span class="txbf">F<span class="smallcaps">OR ALL THE</span> H<span class="smallcaps">OLLYWOOD</span> W<span class="smallcaps">IVES</span></span></a></p><a id="page_viii">
<p class="ded1"><span class="txbf">Old and new . . . male and female . . .</span></p>
<p class="ded1"><span class="txbf">Gay and straight . . .</span></p>
<p class="ded2"><span class="txbf">A constant source of inspiration!</span></p>
<p class="ded3"><span class="txbf">And for A<span class="smallcaps">RNOLD</span> K<span class="smallcaps">OPELSON</span>,</span></p>
<p class="ded1"><span class="txbf">who told me much more than I</span></p>
<p class="ded4"><span class="txbf">ever wanted to know!</span></p>
<p class="ded5"><span class="txbf">And for F<span class="smallcaps">RANK</span>,</span></p>
</a><p class="ded5"><a id="page_viii"><span class="txbf">Always . . .</span></a><a id="page_ix"></a><a id="page_x"></a><a id="page_xi"></a></p><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?691e8504